import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinmumbai() {



    const cardData = {




keyword: "Cab Service in Mumbai",

headingDescription: "Shreesha Tours & Travels provides reliable, affordable, and professional cab services in Mumbai for local travel, airport transfers, corporate transportation, outstation trips, sightseeing tours, railway station transfers, and long-distance travel across Maharashtra and India. We offer one-way cabs, round-trip taxi services, hourly rental packages, chauffeur-driven vehicles, and customized travel solutions for families, business travelers, tourists, students, and corporate clients. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles to suit every travel requirement and budget. With doorstep pickup across Mumbai, experienced drivers, transparent pricing, easy online booking, and 24/7 customer support, Shreesha Tours & Travels ensures a safe, comfortable, and hassle-free travel experience. Whether you need a taxi for business meetings, airport pickup and drop, city sightseeing, weddings, family vacations, pilgrimage tours, or outstation journeys, our Mumbai cab service guarantees punctual service, clean vehicles, and a smooth ride every time.",

topPlaces: [
 
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a beautiful hill station known for Venna Lake, Arthur's Seat, Elephant's Head Point, strawberry farms, and breathtaking viewpoints. It is ideal for couples, families, and nature lovers."
  },
  {
    title: "Panchgani",
    description: "Panchgani attracts tourists with its scenic Table Land, Sydney Point, Parsi Point, Mapro Garden, and pleasant climate. It is one of the best weekend getaway destinations from Mumbai."
  },
  {
    title: "Shirdi",
    description: "Shirdi is one of India's most visited pilgrimage destinations, home to the sacred Shri Sai Baba Samadhi Mandir. Thousands of devotees travel from Mumbai every day for darshan and spiritual experiences."
  },
  {
    title: "Nashik",
    description: "Nashik is famous for Trimbakeshwar Jyotirlinga, Panchavati, Sula Vineyards, and the Godavari River. It is a perfect destination for religious tours, wine tourism, and family vacations."
  },
  {
    title: "Goa",
    description: "Goa is India's most popular beach destination, known for beautiful beaches, water sports, Portuguese churches, vibrant nightlife, forts, and seafood. It is one of the most booked outstation cab routes from Mumbai."
  },
   {
    title: "Lonavala",
    description: "Lonavala is one of the most popular hill stations near Mumbai, famous for Tiger Point, Bhushi Dam, Rajmachi Fort, lush green valleys, waterfalls, and pleasant weather. It is a preferred destination for weekend trips and family vacations."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is renowned for the Mahalakshmi Temple, Rankala Lake, Panhala Fort, traditional cuisine, and rich Maratha heritage. It is an excellent destination for religious and historical tourism."
  },
  {
    title: "Ahmedabad",
    description: "Ahmedabad is Gujarat's largest city, famous for Sabarmati Ashram, Adalaj Stepwell, Kankaria Lake, and rich cultural heritage. It is a popular destination for business and leisure travelers."
  },
  {
    title: "Indore",
    description: "Indore is known for Rajwada Palace, Khajrana Ganesh Temple, Sarafa Night Market, Lal Bagh Palace, and nearby Ujjain and Omkareshwar. It is a preferred destination for business and religious travel."
  },
  {
    title: "Bangalore",
    description: "Bangalore is India's leading IT hub, famous for Lalbagh Botanical Garden, Cubbon Park, Bangalore Palace, ISKCON Temple, and vibrant shopping and dining destinations. It is a popular long-distance cab route from Mumbai."
  }
],



"services": [
  {
    "name": "Cab Service in Mumbai",
    "description": "Book Cab Service in Mumbai for safe, comfortable, and reliable travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, and Tempo Traveller options for local travel, airport transfers, corporate trips, sightseeing, family outings, and outstation journeys with flexible one way and round trip booking."
  },
  {
    "name": "Best Cab Service in Mumbai",
    "description": "Choose the Best Cab Service in Mumbai for premium transportation with experienced drivers, clean vehicles, affordable fares, and excellent customer support. Enjoy hassle-free travel for business meetings, family vacations, airport pickups, hotel transfers, and city tours with punctual and dependable service."
  },
  {
    "name": "Taxi Service in Mumbai",
    "description": "Hire Taxi Service in Mumbai for comfortable local and outstation transportation with professional chauffeurs, transparent pricing, and multiple vehicle options. Experience safe travel with reliable pickups, clean AC cars, and flexible booking for every travel requirement."
  },
  {
    "name": "Cab Booking Mumbai",
    "description": "Complete Cab Booking Mumbai online with instant confirmation, affordable fares, and a wide range of vehicle choices. Select the ideal cab for airport transfers, local rides, family travel, business meetings, sightseeing, and outstation trips."
  },
  {
    "name": "Online Cab Booking Mumbai",
    "description": "Reserve Online Cab Booking Mumbai with quick reservations, instant booking confirmation, and reliable chauffeur-driven vehicles. Enjoy doorstep pickup, flexible schedules, and convenient travel throughout Mumbai and nearby destinations."
  },
  {
    "name": "Mumbai Taxi Service",
    "description": "Book Mumbai Taxi Service for comfortable city rides, airport transfers, corporate travel, hotel pickups, and long-distance journeys. Travel with experienced drivers, clean AC vehicles, and transparent pricing for a smooth travel experience."
  },
  {
    "name": "Mumbai Cab Rental Service",
    "description": "Choose Mumbai Cab Rental Service for chauffeur-driven vehicles available for hourly, daily, local, and outstation travel. Enjoy flexible rental packages, premium comfort, and reliable transportation for every occasion."
  },
  {
    "name": "Mumbai Car Rental with Driver",
    "description": "Hire Mumbai Car Rental with Driver for comfortable private transportation with professional chauffeurs and well-maintained vehicles. Perfect for business executives, tourists, family functions, weddings, and sightseeing tours."
  },
  {
    "name": "Mumbai Local Cab Service",
    "description": "Book Mumbai Local Cab Service for convenient travel across Mumbai with affordable fares, experienced drivers, and comfortable AC vehicles. Ideal for shopping, office commutes, meetings, hospital visits, and daily travel."
  },
  {
    "name": "Mumbai Airport Cab Service",
    "description": "Reserve Mumbai Airport Cab Service for timely airport pickup and drop with flight tracking, professional chauffeurs, and clean AC vehicles. Enjoy stress-free transfers to and from all Mumbai airport terminals."
  },
  {
    "name": "Mumbai Outstation Cab Service",
    "description": "Choose Mumbai Outstation Cab Service for safe and reliable long-distance travel with flexible one way and round trip options. Travel comfortably to destinations across Maharashtra and India with premium chauffeur-driven vehicles."
  },
  {
    "name": "Mumbai One Way Cab Service",
    "description": "Book Mumbai One Way Cab Service for affordable single-trip travel without return charges. Enjoy fixed pricing, professional drivers, comfortable vehicles, and convenient pickup from your preferred location."
  },
  {
    "name": "Mumbai Round Trip Cab Booking",
    "description": "Hire Mumbai Round Trip Cab Booking for convenient return journeys with flexible itineraries, experienced chauffeurs, and economical travel packages. Perfect for business tours, family vacations, pilgrimages, and sightseeing."
  },
  {
    "name": "Mumbai Corporate Cab Service",
    "description": "Choose Mumbai Corporate Cab Service for business meetings, employee transportation, airport transfers, conferences, and executive travel. Enjoy punctual service, premium vehicles, professional chauffeurs, and reliable corporate travel solutions."
  },
  {
    "name": "Mumbai Family Cab Service",
    "description": "Book Mumbai Family Cab Service for safe and spacious travel with comfortable seating, experienced drivers, and well-maintained vehicles. Ideal for vacations, family functions, shopping trips, and weekend outings."
  },
  {
    "name": "Mumbai Private Taxi Service",
    "description": "Reserve Mumbai Private Taxi Service for personalized travel with dedicated chauffeur-driven vehicles offering complete privacy, comfort, flexibility, and reliable transportation for local and outstation journeys."
  },
  {
    "name": "Mumbai AC Cab Service",
    "description": "Choose Mumbai AC Cab Service for comfortable travel in clean, air-conditioned vehicles with professional chauffeurs and affordable fares. Enjoy a pleasant ride for local, airport, business, and outstation travel."
  },
  {
    "name": "Mumbai 24x7 Cab Service",
    "description": "Book Mumbai 24x7 Cab Service anytime for round-the-clock transportation with quick availability, professional drivers, and reliable customer support. Get comfortable rides day or night for airport transfers, emergencies, and long-distance travel."
  },
  {
    "name": "Reliable Cab Service Mumbai",
    "description": "Hire Reliable Cab Service Mumbai for dependable transportation with trained chauffeurs, quality vehicles, transparent pricing, and excellent customer satisfaction. Enjoy safe and punctual travel for every journey."
  },
  {
    "name": "Affordable Cab Service Mumbai",
    "description": "Choose Affordable Cab Service Mumbai for budget-friendly travel without compromising comfort or safety. Get competitive fares, professional drivers, clean AC vehicles, and flexible booking options for local, airport, and outstation trips."
  }
],
"tableData": [
  ["Cab Service in Mumbai", "Best Cab Service in Mumbai"],
  ["Taxi Service in Mumbai", "Cab Booking Mumbai"],
  ["Online Cab Booking Mumbai", "Mumbai Taxi Service"],
  ["Mumbai Cab Rental Service", "Mumbai Car Rental with Driver"],
  ["Mumbai Local Cab Service", "Mumbai Airport Cab Service"],
  ["Mumbai Outstation Cab Service", "Mumbai One Way Cab Service"],
  ["Mumbai Round Trip Cab Booking", "Mumbai Corporate Cab Service"],
  ["Mumbai Family Cab Service", "Mumbai Private Taxi Service"],
  ["Mumbai AC Cab Service", "Mumbai 24x7 Cab Service"],
  ["Reliable Cab Service Mumbai", "Affordable Cab Service Mumbai"]
],




whychoose: [
  {
    WhyChooseheading: "Your Trusted Cab Service in Mumbai",
    WhyChoosedescription: "Getting around Mumbai becomes easier with Shreesha Tours & Travels. We provide reliable cab services for local travel, airport transfers, outstation trips, corporate transportation, sightseeing, and long-distance journeys with comfortable vehicles and professional drivers."
  },
  {
    WhyChooseheading: "Local & Outstation Cabs Under One Roof",
    WhyChoosedescription: "From city rides and airport pickups to outstation tours and interstate travel, our cab service covers a wide range of transportation requirements for individuals, families, and businesses."
  },
  {
    WhyChooseheading: "Extensive Fleet for Every Travel Need",
    WhyChoosedescription: "Choose from Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, Luxury Cars, and Mini Buses to match your travel plans and passenger capacity."
  },
  {
    WhyChooseheading: "Travel Solutions for Every Occasion",
    WhyChoosedescription: "Our cabs are suitable for airport transfers, business meetings, weddings, family vacations, corporate events, sightseeing tours, hotel transfers, pilgrimages, educational trips, and weekend getaways."
  },
  {
    WhyChooseheading: "Professional Chauffeurs with City Expertise",
    WhyChoosedescription: "Our courteous drivers are well acquainted with Mumbai's roads, expressways, business districts, residential areas, and nearby destinations, ensuring timely and comfortable travel."
  },
  {
    WhyChooseheading: "Flexible Booking Options for Every Customer",
    WhyChoosedescription: "Book hourly rental cabs, full-day packages, one-way taxis, round trips, airport transfers, or customized travel itineraries based on your schedule."
  },
  {
    WhyChooseheading: "Well-Maintained & Comfortable Vehicles",
    WhyChoosedescription: "Every vehicle is regularly serviced, thoroughly cleaned, air-conditioned, and equipped with comfortable seating to provide a pleasant travel experience."
  },
  {
    WhyChooseheading: "Reliable Service by Shreesha Tours & Travels",
    WhyChoosedescription: "Enjoy transparent pricing, responsive customer support, and quick booking confirmation whenever you need a dependable cab service in Mumbai."
  }
]

};

const faqData = [
  {
    question: "What types of cab services do you provide in Mumbai?",
    answer: "We offer local taxi services, airport transfers, outstation cabs, corporate travel, sightseeing tours, wedding transportation, hourly rentals, and long-distance interstate taxi services."
  },
  {
    question: "Can I hire a cab for a full day in Mumbai?",
    answer: "Yes, full-day cab rentals and hourly packages are available for personal, business, and sightseeing travel."
  },
  {
    question: "Which vehicles can I book for Mumbai cab service?",
    answer: "You can choose Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, Luxury Cars, and Mini Buses."
  },
  {
    question: "Do you provide airport pickup and drop services?",
    answer: "Yes, we offer airport transfers to and from Mumbai Airport with convenient pickup and drop facilities."
  },
  {
    question: "Can I book a cab for corporate meetings and office travel?",
    answer: "Yes, our taxi services are suitable for business executives, employee transportation, client visits, conferences, and corporate events."
  },
  {
    question: "Are outstation taxi services available from Mumbai?",
    answer: "Yes, we provide one-way and round-trip cab services to destinations across Maharashtra, Gujarat, Goa, Karnataka, Madhya Pradesh, Rajasthan, and other states."
  },
  {
    question: "Can I book a Tempo Traveller for group travel?",
    answer: "Yes, Tempo Travellers and larger vehicles are available for family tours, weddings, school trips, corporate outings, and group travel."
  },
  {
    question: "Is advance booking necessary for Mumbai cab service?",
    answer: "Advance booking is recommended, especially during weekends, holidays, festivals, and peak travel seasons to ensure vehicle availability."
  },
  {
    question: "How is the cab fare calculated?",
    answer: "Cab fares depend on the vehicle category, travel duration, trip type, distance, and any customized itinerary or additional travel requirements."
  },
  {
    question: "How can I book a Cab Service in Mumbai with Shreesha Tours & Travels?",
    answer: "Simply share your pickup location, destination, travel date, passenger count, and preferred vehicle to receive a customized quotation and instant booking assistance."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Siddharth Jain",
    feedback: "I've used Shreesha Tours & Travels several times for airport transfers and business meetings in Mumbai. Their drivers are punctual, the vehicles are clean, and the service is consistently professional.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Megha Kulkarni",
    feedback: "We booked an Innova Crysta for a family outing from Mumbai. The cab was spacious, the driver was courteous, and the entire journey was comfortable. Highly satisfied with the overall experience.",
    rating: 5
  }
];



















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/cab-service-in-mumbai.webp",
  "description":
    "Book Cab Service in Mumbai with Shreesha Tours & Travels for safe, comfortable, and affordable local and outstation taxi services. We offer Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for airport transfers, corporate travel, local sightseeing, business meetings, family trips, and intercity journeys across Mumbai and nearby destinations.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/cab-service-in-mumbai"
  }
};





    return (
        <div>

<Helmet>
  <title>Cab Service in Mumbai | 24x7 Taxi Booking | +91 8355835813</title>

  <meta
    name="description"
    content="Book Cab Service in Mumbai with Shreesha Travels for reliable local, airport, and outstation taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta with professional drivers, affordable fares, and 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Cab Service in Mumbai, Best Cab Service in Mumbai, Taxi Service in Mumbai, Cab Booking Mumbai, Online Cab Booking Mumbai, Mumbai Taxi Service, Mumbai Cab Rental Service, Mumbai Car Rental with Driver, Mumbai Local Cab Service, Mumbai Airport Cab Service, Mumbai Outstation Cab Service, Mumbai Cab Hire, Mumbai Taxi Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/32.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinmumbai;